module.exports = __webpack_public_path__ + "img/logo_sefin_vertical.11fa185b.png";